const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const {apiAdminCustomerRefundEdit} = require("../../../../../../../api/admin/refunds");
const RefundForm = require('../components/RefundForm');

module.exports = ({id, ...data}, update) => openPopupWindow((setPopupState, popup) => {
  const cryptoCode = data.cc_code || '';
  const [network, ccCode] = cryptoCode.includes('_') ? cryptoCode.split('_') : ['', cryptoCode];
  
  const refundCryptoCode = data.refund_cc_code || '';
  const [refundNetwork, refundCcCode] = refundCryptoCode.includes('_') ? refundCryptoCode.split('_') : ['', refundCryptoCode];

  popup.state = {
    ...popup.state,
    ...data,
    crypto_code: ccCode,
    crypto_network: network,
    refund_crypto_code: refundCcCode,
    refund_crypto_network: refundNetwork
  }

  return (stateOfPopup) => {
    return (
      <RefundForm
        caption={(
          <div className="layoutRow aiC">
            <span className="mr10 pr10 b0 br3 bc0 bs">Edit Refund</span>
            <span className="f12">{id}</span>
          </div>
        )}
        state={stateOfPopup}
        setState={setPopupState}
        update={update}
        close={popup.close}
        onSave={(data) => {
          return apiAdminCustomerRefundEdit({issue_id: id, ...data});
        }}
      />
    )
  }
})
